import React, { useState } from "react";
import logo from "../../resource/7.png";
import useFormHandler from "../../Hook/useFormHandler";

const GuestSpeakerOrgReq = () => {
  const initialValues = {
    // Organiser Details
    organiser_full_name: "",
    organiser_dob: "",
    organiser_age: "",
    organiser_mobile_number: "",
    organiser_whatsapp_number: "",
    organiser_email: "",

    // Guest Speaker Details
    speaker_first_name: "",
    speaker_last_name: "",
    speaker_dob: "",
    speaker_age: "",
    speaker_gender: "",
    speaker_type: "",
    vassa_years: "",

    // Residence Details
    monastery_name: "",
    country_of_residence: "",
    address: "",
    city: "",
    postal_code: "",
    country: "",
    speaker_mobile_number: "",
    speaker_phone_with_country_code: "",
    speaker_email: "",

    // Experience Details
    experience_level: "",
    retreat_experience_value: "",
    retreat_experience_unit: "",

    // Retreat Program Details
    retreat_duration: "",
    preferred_days: "",
    preferred_month: "",
    preferred_year: "",
    expected_participants: "",

    // Additional Information
    queries: "",

    ip_address: ""
  };

  const validations = {
    // Organiser Details
    organiser_full_name: {
      required: true,
      pattern: /^[A-Za-z\s\-\.]+$/,
      message: "Full name should contain only letters, spaces, hyphens, or periods",
    },
    organiser_dob: {
      required: true,
      pattern: /^\d{4}-\d{2}-\d{2}$/,
      message: "Date of Birth must be in YYYY-MM-DD format",
    },
    organiser_age: {
      required: true,
      pattern: /^\d+$/,
      message: "Age must be a valid number",
      validate: (value) => {
        const numValue = Number(value);
        return (numValue > 0 && numValue < 120) || "Age must be between 1 and 119";
      },
    },
    organiser_mobile_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Mobile Number should be 10 to 15 digits, with optional '+'",
    },
    organiser_whatsapp_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "WhatsApp Number should be 10 to 15 digits, with optional '+'",
    },
    organiser_email: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },

    // Guest Speaker Details
    speaker_first_name: {
      required: true,
      pattern: /^[A-Za-z\s\-\.]+$/,
      message: "First name should contain only letters, spaces, hyphens, or periods",
    },
    speaker_last_name: {
      required: true,
      pattern: /^[A-Za-z\s\-\.]+$/,
      message: "Last name should contain only letters, spaces, hyphens, or periods",
    },
    speaker_dob: {
      required: true,
      pattern: /^\d{4}-\d{2}-\d{2}$/,
      message: "Date of Birth must be in YYYY-MM-DD format",
    },
    speaker_age: {
      required: true,
      pattern: /^\d+$/,
      message: "Age must be a valid number",
      validate: (value) => {
        const numValue = Number(value);
        return (numValue > 0 && numValue < 120) || "Age must be between 1 and 119";
      },
    },
    speaker_gender: {
      required: true,
      validate: (value) =>
        ["male", "female", "other"].includes(value) || "Gender must be Male, Female, or Other",
    },
    speaker_type: {
      required: true,
      validate: (value) =>
        ["upasampada_monk", "samanera_monk", "nun", "layman"].includes(value) || "Please select speaker type",
    },
    vassa_years: {
      required: false,
      pattern: /^\d*$/,
      message: "Vassa years must be a valid number",
    },

    // Residence Details
    monastery_name: {
      required: true,
      minLength: 3,
      message: "Monastery/Temple name must be at least 3 characters",
    },
    country_of_residence: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Country should contain only letters, spaces, or hyphens",
    },
    address: {
      required: true,
      minLength: 5,
      message: "Address must be at least 5 characters long",
    },
    city: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "City should contain only letters, spaces, or hyphens",
    },
    postal_code: {
      required: true,
      pattern: /^\d{5,10}$/,
      message: "Postal Code should be 5 to 10 digits",
    },
    country: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Country should contain only letters, spaces, or hyphens",
    },
    speaker_mobile_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Mobile Number should be 10 to 15 digits, with optional '+'",
    },
    speaker_phone_with_country_code: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Phone number should be 10 to 15 digits, with optional '+'",
    },
    speaker_email: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },

    // Experience Details
    experience_level: {
      required: true,
      validate: (value) =>
        ["beginner", "experienced_teacher"].includes(value) || "Please select experience level",
    },
    retreat_experience_value: {
      required: true,
      pattern: /^\d+$/,
      message: "Experience value must be a valid number",
      validate: (value) => {
        const numValue = Number(value);
        return (numValue >= 0 && numValue <= 100) || "Experience value must be between 0 and 100";
      },
    },
    retreat_experience_unit: {
      required: true,
      validate: (value) =>
        ["months", "years"].includes(value) || "Please select experience unit",
    },

    // Retreat Program Details
    retreat_duration: {
      required: true,
      validate: (value) =>
        ["1_day", "4_days", "7_days", "10_days"].includes(value) || "Please select retreat duration",
    },
    preferred_days: {
      required: true,
      minLength: 3,
      message: "Please specify preferred days",
    },
    preferred_month: {
      required: true,
      validate: (value) =>
        [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December",
        ].includes(value) || "Please select a valid month",
    },
    preferred_year: {
      required: true,
      pattern: /^\d{4}$/,
      message: "Year must be a 4-digit number",
      validate: (value) => {
        const year = Number(value);
        const currentYear = new Date().getFullYear();
        return (
          year >= currentYear && year <= currentYear + 5
        ) || `Year must be between ${currentYear} and ${currentYear + 5}`;
      },
    },
    expected_participants: {
      required: true,
      pattern: /^\d+$/,
      message: "Number of participants must be a valid number",
      validate: (value) => {
        const numValue = Number(value);
        return (numValue > 0 && numValue <= 1000) || "Number of participants must be between 1 and 1000";
      },
    },

    // Additional Information
    queries: {
      required: false,
      maxLength: 1000,
      message: "Queries cannot exceed 1000 characters",
    },
  };

  const endpoint = '/create-guest-speaker-registrations';

  const transformForApi = (data) => ({
    // Organiser Details
    organiser_full_name: data.organiser_full_name,
    organiser_dob: data.organiser_dob,
    organiser_age: Number(data.organiser_age),
    organiser_mobile_number: data.organiser_mobile_number,
    organiser_whatsapp_number: data.organiser_whatsapp_number,
    organiser_email: data.organiser_email,

    // Guest Speaker Details
    speaker_first_name: data.speaker_first_name,
    speaker_last_name: data.speaker_last_name,
    speaker_dob: data.speaker_dob,
    speaker_age: Number(data.speaker_age),
    speaker_gender: data.speaker_gender,
    speaker_type: data.speaker_type,
    vassa_years: data.vassa_years ? Number(data.vassa_years) : 0,

    // Residence Details
    monastery_name: data.monastery_name,
    country_of_residence: data.country_of_residence,
    address: data.address,
    city: data.city,
    postal_code: data.postal_code,
    country: data.country,
    speaker_mobile_number: data.speaker_mobile_number,
    speaker_phone_with_country_code: data.speaker_phone_with_country_code,
    speaker_email: data.speaker_email,

    // Experience Details
    experience_level: data.experience_level,
    retreat_experience_value: Number(data.retreat_experience_value),
    retreat_experience_unit: data.retreat_experience_unit,

    // Retreat Program Details
    retreat_duration: data.retreat_duration,
    preferred_days: data.preferred_days,
    preferred_month: data.preferred_month,
    preferred_year: Number(data.preferred_year),
    expected_participants: Number(data.expected_participants),

    // Additional Information
    queries: data.queries,
    ip_address: data.ip_address,
  });

  const {
    formData,
    errors,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
  } = useFormHandler({
    initialValues,
    validations,
    endpoint,
    includeIP: true,
    transformFn: transformForApi
  });

  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="Monastery Logo" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">
              Guest Speaker Retreat Registration Form for Organisers
            </h2>
          </div>
        </div>

        <p className="mt-6 font-p">
          Welcome to Bhaddheka Vihari Monastery Guest Speaker Retreats.
        </p>
        <p className="font-p mt-4">
          Please make sure you read the terms and conditions of the Rules and
          Regulations of the Meditation Retreat before submitting this
          application form. As the organiser for the guest speaker, use the
          following form to fill in the guest speaker and organiser details.
        </p>

        <h2 className="font-second mt-5">Organiser Details</h2>
        
        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="organiser_full_name"
              name="organiser_full_name"
              value={formData.organiser_full_name}
              onChange={handleInputChange}
            />
            <label htmlFor="organiser_full_name">Full Name of the Organiser*</label>
            {errors.organiser_full_name && <span className="error">{errors.organiser_full_name}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              id="organiser_dob"
              name="organiser_dob"
              value={formData.organiser_dob}
              onChange={handleInputChange}
            />
            <label htmlFor="organiser_dob">Date of Birth*</label>
            {errors.organiser_dob && <span className="error">{errors.organiser_dob}</span>}
          </div>
          <div className="form-item">
            <input
              type="number"
              id="organiser_age"
              name="organiser_age"
              value={formData.organiser_age}
              onChange={handleInputChange}
            />
            <label htmlFor="organiser_age">Age*</label>
            {errors.organiser_age && <span className="error">{errors.organiser_age}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="organiser_mobile_number"
              name="organiser_mobile_number"
              value={formData.organiser_mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="organiser_mobile_number">Mobile Number*</label>
            {errors.organiser_mobile_number && <span className="error">{errors.organiser_mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="organiser_whatsapp_number"
              name="organiser_whatsapp_number"
              value={formData.organiser_whatsapp_number}
              onChange={handleInputChange}
            />
            <label htmlFor="organiser_whatsapp_number">WhatsApp Number*</label>
            {errors.organiser_whatsapp_number && <span className="error">{errors.organiser_whatsapp_number}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              id="organiser_email"
              name="organiser_email"
              value={formData.organiser_email}
              onChange={handleInputChange}
            />
            <label htmlFor="organiser_email">Email Address*</label>
            {errors.organiser_email && <span className="error">{errors.organiser_email}</span>}
          </div>
        </div>

        <h2 className="font-second mt-5">Guest Speaker Details</h2>
        
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="speaker_first_name"
              name="speaker_first_name"
              value={formData.speaker_first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_first_name">First Name*</label>
            {errors.speaker_first_name && <span className="error">{errors.speaker_first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="speaker_last_name"
              name="speaker_last_name"
              value={formData.speaker_last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_last_name">Last Name*</label>
            {errors.speaker_last_name && <span className="error">{errors.speaker_last_name}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              id="speaker_dob"
              name="speaker_dob"
              value={formData.speaker_dob}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_dob">Date of Birth*</label>
            {errors.speaker_dob && <span className="error">{errors.speaker_dob}</span>}
          </div>
          <div className="form-item">
            <input
              type="number"
              id="speaker_age"
              name="speaker_age"
              value={formData.speaker_age}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_age">Age*</label>
            {errors.speaker_age && <span className="error">{errors.speaker_age}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="male"
              name="speaker_gender"
              value="male"
              checked={formData.speaker_gender === "male"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="male">Male</label>
          </div>
          <div>
            <input
              type="radio"
              id="female"
              name="speaker_gender"
              value="female"
              checked={formData.speaker_gender === "female"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="female">Female</label>
          </div>
          <div>
            <input
              type="radio"
              id="other"
              name="speaker_gender"
              value="other"
              checked={formData.speaker_gender === "other"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="other">Other</label>
          </div>
        </div>
        {errors.speaker_gender && <span className="error">{errors.speaker_gender}</span>}

        <p className="font-p mt-5">Please indicate if the guest teacher is*</p>
        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="upasampada">Upasampada Monk</label>
            <input
              type="radio"
              id="upasampada"
              name="speaker_type"
              value="upasampada_monk"
              checked={formData.speaker_type === "upasampada_monk"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="samanera">Samanera Monk</label>
            <input
              type="radio"
              id="samanera"
              name="speaker_type"
              value="samanera_monk"
              checked={formData.speaker_type === "samanera_monk"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="nun">Nun</label>
            <input
              type="radio"
              id="nun"
              name="speaker_type"
              value="nun"
              checked={formData.speaker_type === "nun"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="layman">Layman</label>
            <input
              type="radio"
              id="layman"
              name="speaker_type"
              value="layman"
              checked={formData.speaker_type === "layman"}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.speaker_type && <span className="error">{errors.speaker_type}</span>}

        <div className="form-item mt-5">
          <label htmlFor="vassa_years" className="font-p">
            If Upasampada monk, please indicate number of vassa
          </label>
          <input
            type="number"
            id="vassa_years"
            name="vassa_years"
            value={formData.vassa_years}
            onChange={handleInputChange}
            min="0"
            max="100"
          />
          {errors.vassa_years && <span className="error">{errors.vassa_years}</span>}
        </div>

        <h2 className="font-second mt-5">Residence Details</h2>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="monastery_name"
              name="monastery_name"
              value={formData.monastery_name}
              onChange={handleInputChange}
            />
            <label htmlFor="monastery_name">Name of the Monastery or Temple of Residence*</label>
            {errors.monastery_name && <span className="error">{errors.monastery_name}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="country_of_residence"
              name="country_of_residence"
              value={formData.country_of_residence}
              onChange={handleInputChange}
            />
            <label htmlFor="country_of_residence">Country of Residence*</label>
            {errors.country_of_residence && <span className="error">{errors.country_of_residence}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Address*</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City*</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal Code*</label>
            {errors.postal_code && <span className="error">{errors.postal_code}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
            />
            <label htmlFor="country">Country*</label>
            {errors.country && <span className="error">{errors.country}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="speaker_mobile_number"
              name="speaker_mobile_number"
              value={formData.speaker_mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_mobile_number">Mobile Number*</label>
            {errors.speaker_mobile_number && <span className="error">{errors.speaker_mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="speaker_phone_with_country_code"
              name="speaker_phone_with_country_code"
              value={formData.speaker_phone_with_country_code}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_phone_with_country_code">Phone Number with Country Code*</label>
            {errors.speaker_phone_with_country_code && <span className="error">{errors.speaker_phone_with_country_code}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              id="speaker_email"
              name="speaker_email"
              value={formData.speaker_email}
              onChange={handleInputChange}
            />
            <label htmlFor="speaker_email">Email Address*</label>
            {errors.speaker_email && <span className="error">{errors.speaker_email}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate if the Guest Speaker is an experienced teacher or a beginner*
        </p>

        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="beginner">Beginner</label>
            <input
              type="radio"
              id="beginner"
              name="experience_level"
              value="beginner"
              checked={formData.experience_level === "beginner"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="experienced">Experienced teacher</label>
            <input
              type="radio"
              id="experienced"
              name="experience_level"
              value="experienced_teacher"
              checked={formData.experience_level === "experienced_teacher"}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.experience_level && <span className="error">{errors.experience_level}</span>}

        <p className="font-p mt-5">
          Please indicate the Guest Speaker's level of experience conducting retreats*
        </p>

        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="number"
              id="retreat_experience_value"
              name="retreat_experience_value"
              value={formData.retreat_experience_value}
              onChange={handleInputChange}
              min="0"
              max="100"
            />
            <label htmlFor="retreat_experience_value">Experience Value*</label>
            {errors.retreat_experience_value && <span className="error">{errors.retreat_experience_value}</span>}
          </div>
          <div className="form-item">
            <select
              id="retreat_experience_unit"
              name="retreat_experience_unit"
              value={formData.retreat_experience_unit}
              onChange={handleInputChange}
              style={{ padding: "6px", borderRadius: "4px", width: "100%" }}
            >
              <option value="">Select Unit</option>
              <option value="months">Months</option>
              <option value="years">Years</option>
            </select>
            <label htmlFor="retreat_experience_unit">Experience Unit*</label>
            {errors.retreat_experience_unit && <span className="error">{errors.retreat_experience_unit}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please indicate the duration of the retreat program*
        </p>

        <div className="selection mt-4">
          <div className="checkbox-box">
            <label htmlFor="1_day">1 Day</label>
            <input
              type="radio"
              id="1_day"
              name="retreat_duration"
              value="1_day"
              checked={formData.retreat_duration === "1_day"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="4_days">4 Days</label>
            <input
              type="radio"
              id="4_days"
              name="retreat_duration"
              value="4_days"
              checked={formData.retreat_duration === "4_days"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="7_days">7 Days</label>
            <input
              type="radio"
              id="7_days"
              name="retreat_duration"
              value="7_days"
              checked={formData.retreat_duration === "7_days"}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="10_days">10 Days</label>
            <input
              type="radio"
              id="10_days"
              name="retreat_duration"
              value="10_days"
              checked={formData.retreat_duration === "10_days"}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.retreat_duration && <span className="error">{errors.retreat_duration}</span>}

        <p className="font-p mt-5">
          Please indicate which days, month and year you wish to conduct the retreat program*
        </p>

        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="preferred_days"
              name="preferred_days"
              value={formData.preferred_days}
              onChange={handleInputChange}
            />
            <label htmlFor="preferred_days">Preferred Days* (e.g., Monday to Friday)</label>
            {errors.preferred_days && <span className="error">{errors.preferred_days}</span>}
          </div>
        </div>

        <div className="form-box mt-4">
          <div className="form-item">
            <select
              id="preferred_month"
              name="preferred_month"
              value={formData.preferred_month}
              onChange={handleInputChange}
              style={{ padding: "6px", borderRadius: "4px", width: "100%" }}
            >
              <option value="">Select Month</option>
              <option value="January">January</option>
              <option value="February">February</option>
              <option value="March">March</option>
              <option value="April">April</option>
              <option value="May">May</option>
              <option value="June">June</option>
              <option value="July">July</option>
              <option value="August">August</option>
              <option value="September">September</option>
              <option value="October">October</option>
              <option value="November">November</option>
              <option value="December">December</option>
            </select>
            <label htmlFor="preferred_month">Preferred Month*</label>
            {errors.preferred_month && <span className="error">{errors.preferred_month}</span>}
          </div>
          <div className="form-item">
            <input
              type="number"
              id="preferred_year"
              name="preferred_year"
              value={formData.preferred_year}
              onChange={handleInputChange}
              min={new Date().getFullYear()}
              max={new Date().getFullYear() + 5}
            />
            <label htmlFor="preferred_year">Preferred Year*</label>
            {errors.preferred_year && <span className="error">{errors.preferred_year}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="number"
              id="expected_participants"
              name="expected_participants"
              value={formData.expected_participants}
              onChange={handleInputChange}
              min="1"
              max="1000"
            />
            <label htmlFor="expected_participants">Number of Expected Participants*</label>
            {errors.expected_participants && <span className="error">{errors.expected_participants}</span>}
          </div>
        </div>

        <p className="font-p mt-5">
          Please ask any specific questions or queries you would like to clarify regarding Guest Speaker retreats at the monastery.
        </p>
        
        <div className="form-item mt-4">
          <textarea
            id="queries"
            name="queries"
            value={formData.queries}
            onChange={handleInputChange}
            rows="6"
            placeholder="Optional - write any questions or queries..."
          />
          {errors.queries && <span className="error">{errors.queries}</span>}
        </div>

        <button
          type="submit"
          id="submitbtn"
          className="mt-5"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <p className="font-p mt-5 pb-4">
          We look forward to facilitating your request and are grateful for choosing Bhaddheka Vihari Monastery as an enriching space for practicing mindfulness meditation.
        </p>
      </form>
    </div>
  );
};

export default GuestSpeakerOrgReq;